"use strict";
// import React, { ReactNode } from "react";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoFeedComponent = void 0;
// interface IProps {
//   auction: any;
// }
// export const VideoFeedComponent = (props: IProps) => {
//   const {
//     auction: {
//       live_stream: { id, stream_name },
//     },
//   } = props;
//   // const stream_id = process.env.MILLICAST_STREAM_ID;
//   // console.log("millicast", millicast);
//   // console.log(stream_id, stream_name);
//   return (
//     <div className="bg-black rounded-lg overflow-clip min-w-96 min-h-60 lg:min-h-72 grid">
//       {/* TODO maybe lets also implement youtube livestream for non-registered users */}
//       {/* <iframe className="w-full h-full" src={`https://viewer.millicast.com/?streamId=${id}/${stream_name}`} /> */}
//       <iframe className="w-full h-full" src={`https://viewer.millicast.com/?streamId=XXdh8F/${stream_name}`} />
//     </div>
//   );
// };
var react_1 = __importDefault(require("react"));
var VideoFeedComponent = function (props) {
    var _a, _b;
    // const {
    //   auction: {
    //     live_stream: { stream_name },
    //   },
    // } = props;
    var stream_name = (_b = (_a = props === null || props === void 0 ? void 0 : props.auction) === null || _a === void 0 ? void 0 : _a.live_stream) === null || _b === void 0 ? void 0 : _b.stream_name;
    console.log(props.auction, "auction");
    // const stream_id = process.env.MILLICAST_STREAM_ID;
    // console.log("millicast", millicast);
    // console.log(stream_id, stream_name);
    return (react_1.default.createElement("div", { className: "bg-black rounded-lg overflow-clip min-w-96 min-h-60 lg:min-h-72 grid" },
        react_1.default.createElement("iframe", { className: "w-full h-full", src: "https://viewer.millicast.com/?streamId=XXdh8F/".concat(stream_name, " ") })));
};
exports.VideoFeedComponent = VideoFeedComponent;
